module.exports = __webpack_public_path__ + "img/instagram-image.31eb918f.png";